import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import nl2br from 'react-nl2br';
import GoogleMapReact from 'google-map-react';
import {
  Row,
  Col,
} from 'reactstrap';
import styled from 'styled-components';
import config from '../../config';

const Container = styled.div`
  margin-top: 130px;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 1.25rem;
  font-size: 2rem;
`;

const Description = styled.p`
  text-align: center;
`;

const MapContainer = styled.div`
  width: 100%;
  height: 400px;
  margin-top: 2rem;
  pointer-events: none;
`;

class Access extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  }

  componentDidMount() {
    // eslint-disable-next-line no-undef
    window.scrollTo(0, 0);
  }

  renderMarkers(map, maps) {
    new maps.Marker({
      position: {
        lat: 35.6673115,
        lng: 139.8563896,
      },
      map,
      title: 'ASO SPORTS CENTER',
    });
  }

  render() {
    const { intl } = this.props;

    return (
      <Container className="marketing container">
        <Row className="featurette">
          <Col md={{ size: 10, offset: 1 }}>
            <Title className="featurette-heading">
              {nl2br(intl.formatMessage({
                id: 'Access.Title',
              }))}
            </Title>
            <Description>
              <a
                href="https://www.oakhouse.jp/eng/house/672"
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: '1.25rem' }}
              >
                https://www.oakhouse.jp/eng/house/672
              </a>
            </Description>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <MapContainer>
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: config.GOOGLE_API_KEY,
                  // language: this.props.lang,
                  // region: this.props.lang,
                  maptype: 'roadmap',
                  style: 'element:geometry%7Ccolor:0xf5f5f5',
                }}
                defaultCenter={{
                  lat: 35.6673115,
                  lng: 139.8543377,
                }}
                defaultZoom={17}
                style={{
                  width: '100%',
                  height: '100%',
                  margin: 0,
                  padding: 0,
                  position: 'relative',
                }}
                onGoogleApiLoaded={({ map, maps }) => this.renderMarkers(map, maps)}
                yesIWantToUseGoogleMapApiInternals
                options={{
                  // styles: config.GOOGLE_MAPS_STYLE,
                  mapTypeControl: false,
                  panControl: false,
                  streetViewControl: false,
                  zoomControl: false,
                  fullscreenControl: false,
                }}
              />
            </MapContainer>
          </Col>
        </Row>
        <Row>
          <Col md="12" className="d-flex flex-row justify-content-center">
            <a
              href="https://goo.gl/maps/ZA6cHRviQBqZyV2q8"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-md btn-primary mt-4"
            >
              Google Maps
            </a>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default injectIntl(Access);
